import $ from "jquery";
import globalConfigVariables from './configs.js';
import "jquery-match-height";
import $script from 'scriptjs';
var moment = require('moment');

const $processingWrapper = $(".processing");
const $weekSelectDropdown = $(".select-week");

var authManageProjects = false;
var weekDaysDates = [];

var weeks = {
    week4: {
        offSet: 0,
        range: moment().startOf("isoWeek").add(0, 'days').format("Do MMM") + " - " + moment().startOf("isoWeek").add(6, 'days').format("Do MMM"),
        startOfWeek: moment().startOf("isoWeek").add(0, 'days')
    },
    week3: {
        offSet: -1,
        range: moment().startOf("isoWeek").subtract(1, 'weeks').format("Do MMM") + " - " + moment().startOf("isoWeek").subtract(1, 'weeks').add(6, 'days').format("Do MMM"),
        startOfWeek: moment().startOf("isoWeek").subtract(1, 'weeks')
    },
    week2: {
        offSet: -2,
        range: moment().startOf("isoWeek").subtract(2, 'weeks').format("Do MMM") + " - " + moment().startOf("isoWeek").subtract(2, 'weeks').add(6, 'days').format("Do MMM"),
        startOfWeek: moment().startOf("isoWeek").subtract(2, 'weeks')
    },
    week1: {
        offSet: -3,
        range: moment().startOf("isoWeek").subtract(3, 'weeks').format("Do MMM") + " - " + moment().startOf("isoWeek").subtract(3, 'weeks').add(6, 'days').format("Do MMM"),
        startOfWeek: moment().startOf("isoWeek").subtract(3, 'weeks')
    }
}

function renderHeaderDates(dates) {
    var container = $(".weeks table thead");
    if (!container) return;
    var row = document.createElement('tr');
    container.html('');

    var createCell = function(data, className) {
        var cell = document.createElement('th');
        cell.scope = 'col';
        cell.innerHTML = data
        if (className)
            cell.className = className;

        row.append(cell)
    }   

    createCell('Client', 'text-center')
    createCell('Project')

    dates.forEach(function(item) {
        var htmlStr = '<span class="date">' + moment(item.Date).format('dd, Do') + '</span><br><span class="month">' + moment(item.Date).format('MMM') + '</span>'
        // var htmlStr = '<span class="date">' + moment(item.Date).format('DD/MM') + '</span>'
        createCell(htmlStr)
    })

    createCell('')

    container.append(row)

}

function getMonthlySummary() {
    var getClientsProjectsApi = globalConfigVariables.apiDomain + "staff/timesheet/entries/monthly-summary"
    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var monthTotalHours = 0;

    var monthRange = $(".month-range");
    monthRange.html(moment().format("MMMM"));

    $.ajax({
        url: getClientsProjectsApi,
        headers: {
            'Authorization': authHeader,
        },

        success: function(resp) {
            console.log('response for monthly summary', resp)
            var monthlySummary = $('#_monthly_summary tbody')
            monthlySummary.html('');

            resp.forEach(function(item, i) {
                monthTotalHours += parseInt(item.Hours);
                monthlySummary.append('<tr><td>' + item.Client.Name + '</td><td align="center">' + item.Hours + '</td></tr>')
            });

            monthlySummary.append('<tr><td></td><td align="center" class="font-bold">' + monthTotalHours + '</td></tr>')
        }

    })
  
}


function getPreviousMonthlySummary() {
    var getClientsProjectsApi = globalConfigVariables.apiDomain + "staff/timesheet/entries/monthly-summary?offset=-1"
    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    
    var $prevMonthSummary = $('.prev-month-summary');
    
    var $prevMonthRange = $(".prev-month-range");
    $prevMonthRange.html(moment().subtract(1, 'month').format("MMMM"));

    $.ajax({
        url: getClientsProjectsApi,
        headers: {
            'Authorization': authHeader,
        }
    }).done(function(data) {
        $prevMonthSummary.removeClass('d-none')
        var $table = $prevMonthSummary.find('table');
        
        $table.find('tbody').html('')

        var tableRows = data.map(project => {
            return $('<tr><td>' + project.Client.Name + '</td><td align="center">' + project.Hours + '</td></tr>')
        })
        tableRows.forEach($el => $table.prepend($el))

        var prevMonthTotalHours = data.reduce((total, project) => total += project.Hours, 0)        
        $table.append($('<tr><td></td><td align="center" class="font-bold">' + prevMonthTotalHours + '</td></tr>'))
    })
  
}

function getClientsProjects(){

    var selectedWeek = Object.assign({}, Object.keys(weeks).filter(
                                        key => weeks[key].offSet == $weekSelectDropdown.val()
                                    ));

    console.log("selectedWeek", weeks[selectedWeek[0]]);

    var $clientsWrapper = $(".weeks");
    $clientsWrapper.html("");
    const tableTemplateLit = `<div class="table-wrapper">
                            <div class="table-responsive">
                                <table id="_data_table" class="table table-bordered table-hover table-sm">
                                    <thead>
                                        <tr>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div class="table-button text-right">
                                <button type="button" class="btn btn-dar add-project"><i class="fas fa-plus-circle"></i> Project</button>
                            </div>
                        </div>`;
    
    $clientsWrapper.append('<div class="week">'+tableTemplateLit+"</div>");
    addProject();

    //console.log("globalConfigVariables", globalConfigVariables);
    var getProjectsApi = globalConfigVariables.apiDomain + "clients/projects";
    var getClientsProjectsApi = globalConfigVariables.apiDomain + "projects/timesheet/week?weekOffset="+$weekSelectDropdown.val();

    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;

    $.ajax({
        url: getClientsProjectsApi,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
                //console.log("401");
                signOutDashboard(401);
            }
        },
        success: function(res) {
            console.log(res);
            
            weekDaysDates = res.WeekDays.map(function(item) {
                return item.Date
            })
            
            res.ProjectHours.forEach(function(project, index){

                var projectRowHtml = "";
                projectRowHtml += '<tr valign="middle" data-clientId="" data-projectId="'+project.Id+'">';
                projectRowHtml += "<td class='text-center'>"+project.Client+"</td>";
                projectRowHtml += "<td><div class='project-name'>"+project.Name+"</div><div class='project-code'>jobNo.: "+project.Code+"</div></td>";
                for (var days in project.WeeklyHours) {
                    if (project.WeeklyHours.hasOwnProperty(days)) {
                        var totalHours = 0;

                        if(project.WeeklyHours[days]!=null){
                            totalHours = project.WeeklyHours[days].TotalHours;
                        }

                        projectRowHtml += '<td><div class="input-tip"></div><div class="input-wrapper"><input class="project-hours-input text-center" data-date="'+days+'" type="text" name="projectHours" value="'+totalHours+'"></div></td>';
                    }
                }


                projectRowHtml += '<td><a class="delete-week font-10"><i class="fas fa-trash"></i><a/></td>';
                projectRowHtml += "</tr>";
                $clientsWrapper.find("table tbody").append(projectRowHtml);
                

                

            });
            var totals = res.ProjectHours.reduce(function(total, project) {
                for(var key in project.WeeklyHours) {
                    total[key] = (total[key] || 0) + project.WeeklyHours[key].TotalHours
                }
                return total;
            },{})
            var tableTotalRow = '<tr id="_table_totals" class="font-weight-bold"><td colspan="2" align="right">Total Hours</td>'


            for (var key in totals) {
                tableTotalRow += '<td align="center">' + totals[key] + '</td>'
            }
            tableTotalRow+= '<td></tr>';
            $clientsWrapper.find("table tbody").append(tableTotalRow);

            renderHeaderDates(res.WeekDays)

        },
    });

    $.ajax({
        url: getProjectsApi,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
                signOutDashboard(401);
            }
        },
        success: function(res) {
            setAddProjectsDropdowns(res);
        }
    });

}


function getProjectHours(projectId, callBack){
	var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var getHoursAPI = globalConfigVariables.apiDomain + 'projects/' +  projectId + '/timesheet/week?weekOffset=0';
    $.ajax({
        url: getHoursAPI,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        success: function(res) {
            //console.log(res);
            callBack(res);
        },
    });
}


function setProjectHours(){

    $(document).on("keypress keyup blur","[name='projectHours']", function(event){
        $(this).val($(this).val().replace(/[^0-9\.]/g,''));
        if ( (event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57) ) {
                event.preventDefault();
        }
        
        if(parseFloat($(this).val()) > 24 ){
            $(this).val(24);
        }

    });

    $(document).on("focusin","[name='projectHours']", function(event){
        $(this).data('val', $(this).val());
    });

    $(document).on("focusout","[name='projectHours']", function(event){

        var prevVal = $(this).data('val');
        var currentVal = $(this).val();

        var gTokenId = localStorage.getItem('tokenId');
        var authHeader = 'bearer '+ gTokenId;
        var projectId = $(this).parents("tr").data("projectid");
        var setHoursAPI = globalConfigVariables.apiDomain + 'projects/' +  projectId + '/timesheet/entries';
        var saveData = JSON.stringify({"Entries":[{"Date":$(this).data("date"),"TotalHours":$(this).val()}]});
        //console.log("saveData", saveData);

        if(prevVal !== currentVal){

            if( parseFloat(currentVal) <= 24 ){

                $processingWrapper.fadeIn();

                $.ajax({
                    url: setHoursAPI,
                    headers: {
                        'Authorization': authHeader,
                    },
                    type: 'POST',
                    contentType: "application/json",
                    dataType: 'json',
                    data: saveData,
                    statusCode: {
                        200: function() {
                            calculateTotal();
                            getMonthlySummary();
                            getPreviousMonthlySummary();
                            $processingWrapper.fadeOut();
                        }
                    },
                    success: function(res) {
                        console.log('test works');
                    },
                });
                
            } else {
                
            }

           
        }
        
    });

}

function calculateTotal() {
    var totals = {}
    console.log("aaaaaaaaaaaaaaaaaa",$('#_data_table tbody:not(:last-child)'))
    $('#_data_table tbody').children().each(function(index1, w) {
        if (this.id == '_table_totals') return;

        $(this).children().each(function(index) {
            var inputEl = $(this).find('.input-wrapper > input')
            if (inputEl.length === 0) return
            var date = inputEl.data('date')
            totals[date] = parseInt(totals[date] || 0) + parseInt(inputEl.val() || 0)
        })
    })
    
    console.log('totals', totals)
    var tableTotalRow = '<td colspan="2" align="right">Total Hours</td>'


    for (var key in totals) {
        tableTotalRow += '<td align="center">' + totals[key] + '</td>'
    }
    tableTotalRow+= '<td></td>';
    $('#_table_totals').html(tableTotalRow)


}


function setAddProjectsDropdowns(clinetsProjects){

    var $selectClientDropdown = $(".client-dropdown");
    var $selectProjectDropdown = $(".project-dropdown");

    $selectClientDropdown.html("");
    $selectClientDropdown.append('<option value="0" disabled selected>Select Client</option>');

    clinetsProjects.forEach(function(client, index){
        
        $selectClientDropdown.append('<option value="'+client.Id+'">'+client.Name+'</option>');

    });

    $selectClientDropdown.on("change", function(){
        var $this = $(this);

        var filteredProjects = clinetsProjects.filter(function(project){
                                    return project.Id == $this.val();
                                });

        console.log(filteredProjects);

        $selectProjectDropdown.html("");
        $selectProjectDropdown.append('<option value="0" disabled selected>Select Project</option>');

        if(filteredProjects[0].Projects.length>0){
            filteredProjects[0].Projects.forEach(function(project, index){
                $selectProjectDropdown.append('<option data-projectcode="'+project.Code+'" value="'+project.Id+'">'+project.Name+'</option>');
            });
            $selectProjectDropdown.parent().removeClass("d-none");
        } else {
            $selectProjectDropdown.parent().addClass("d-none");
        }

    });


}


function addProject(){

    var addProjectButton = $(".week .add-project");
    var addProjectModal = $("#addProjectModal");
    addProjectButton.off('click')
    addProjectButton.on("click", function(event){

        var weekTable = $(this).parents(".week").find("table");
        addProjectModal.modal("show");

        addProjectModal.find(".add-project-to-table").off('click')
        addProjectModal.find(".add-project-to-table").on("click", function(){

            $(this).attr("disabled","disabled");

            var selectedClientProject = {
                Client: {
                    Name: addProjectModal.find(".client-dropdown option:selected").text(),
                    Id: addProjectModal.find(".client-dropdown").val()
                },
                Project: {
                    Name: addProjectModal.find(".project-dropdown option:selected").text(),
                    Id: addProjectModal.find(".project-dropdown").val(),
                    Code: addProjectModal.find(".project-dropdown option:selected").data("projectcode")
                }
            }

            console.log("selectedClientProject", selectedClientProject);

            if(selectedClientProject.Client.Id==null){
                addProjectModal.find(".client-dropdown").addClass("error");
            } else {
                addProjectModal.find(".client-dropdown").removeClass("error");
            }

            if(selectedClientProject.Project.Id==null){
                addProjectModal.find(".project-dropdown").addClass("error");
            } else {
                addProjectModal.find(".project-dropdown").removeClass("error");
            }
            
            if( (selectedClientProject.Client.Id!=null) && (selectedClientProject.Project.Id!=null) ){
                $(this).attr("disabled","disabled");
                var projectRowHtml = "";
            
                projectRowHtml += '<tr valign="middle" data-clientId="'+selectedClientProject.Client.Id+'" data-projectId="'+selectedClientProject.Project.Id+'">';
                projectRowHtml += "<td class='text-center'>"+selectedClientProject.Client.Name+"</td>";
                projectRowHtml += "<td><div class='project-name'>"+selectedClientProject.Project.Name+"</div><div class='project-code'>jobNo.: "+selectedClientProject.Project.Code+"</div></td>";
                

                console.log('weeekd days', weekDaysDates);
                if(weekDaysDates.length>0){
                    $.each(weekDaysDates, function(index, day){
                        projectRowHtml += '<td><div class="input-tip"></div><div class="input-wrapper"><input class="project-hours-input text-center" data-date="'+day+'" type="text" name="projectHours" value="0"></div></td>';
                    });
                } else {

                    for(var i=0; i<7; i++){
                        console.log("Day: ", moment().startOf("isoWeek").add(i, 'days').format("YYYY-MM-DD"));
                        projectRowHtml += '<td><div class="input-tip"></div><div class="input-wrapper"><input class="project-hours-input text-center" data-date="'+ moment().startOf("isoWeek").add(i, 'days').format("YYYY-MM-DD") +'" type="text" name="projectHours" value="0"></div></td>';
                    }

                }

                projectRowHtml += '<td><a class="font-10 delete-week"><i class="fas fa-trash"></i><a/></td>';
                projectRowHtml += "</tr>";

                addProjectModal.modal("hide");
                $(projectRowHtml).insertBefore(weekTable.find("tbody tr").last())
                // weekTable.find("tbody tr").append(projectRowHtml);
            } else {
                $(this).removeAttr("disabled");
            }
            
        });

    });

    addProjectModal.on("hidden.bs.modal", function(event){
        $(this).find(".add-project-to-table").removeAttr("disabled");
    });

}


function signOutDashboard(status){
    var $dashBoard = $(".dashboard");
    //Check google Sign auth status
    if($dashBoard.length){
        $script.get('https://apis.google.com/js/platform.js', function () {
            gapi.load('auth2', function() {
                gapi.auth2.init().then(function(){

                    if( !(gapi.auth2.getAuthInstance().isSignedIn.get()) ){
                        window.location.replace('/index.html');
                    }

                    if(status==401){
                        gapi.auth2.getAuthInstance().signOut().then(function() {
                            localStorage.removeItem('getName');
                            console.log('User signed out.');
                            window.location.replace('/index.html');
                        });
                    }
                });
            });
        })   
    }
}


function deleteWeek(){

    $(document).on("click", ".delete-week", function(event){
        $processingWrapper.fadeIn();

        var $this = $(this);
        var $row = $this.parents("tr");

        var gTokenId = localStorage.getItem('tokenId');
        var authHeader = 'bearer '+ gTokenId;
        var projectId = $row.data("projectid");
        var setHoursAPI = globalConfigVariables.apiDomain + 'projects/' +  projectId + '/timesheet/entries';
        var datesObjects = [];

        $.each($row.find("td"), function(index, column){
            console.log("column", column);
            $(column).find("input").val("0");

            if($(column).find("input").data("date")){
                datesObjects.push({
                    "Date": $(column).find("input").data("date"),
                    "TotalHours": 0
                });
            }

        })

        var saveData = JSON.stringify({"Entries":datesObjects});

        $.ajax({
            url: setHoursAPI,
            headers: {
                'Authorization': authHeader,
            },
            type: 'POST',
            contentType: "application/json",
            dataType: 'json',
            data: saveData,
            statusCode: {
                200: function() {
                    $row.remove();
                    calculateTotal()
                    $processingWrapper.fadeOut();
                }
            },
            success: function(res) {
                console.log(res);
            },
        });

    })

}


function setWeekSelectDropdown(){

    if($weekSelectDropdown.length){


        $weekSelectDropdown.html("");

        for(var week in weeks){
            if(weeks[week].offSet == 0){
                $weekSelectDropdown.append('<option value="'+weeks[week].offSet+'">This Week</option>');
            } else {
                $weekSelectDropdown.append('<option value="'+weeks[week].offSet+'">'+weeks[week].range+'</option>');
            }
        }

        $weekSelectDropdown.on("change", function(event){
            getClientsProjects();
        });


    }

}


function checkUserAuthToManageProject(){
    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var getStaffContextAPI = globalConfigVariables.apiDomain + 'staff/context';

    $.ajax({
        url: getStaffContextAPI,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
             signOutDashboard(401);
            }
        },
        success: function(res) {
            var permissions = res.Permissions;
            if(permissions.length){
                permissions.forEach(function(permission){
                    if(permission.Id == "38e007cc-3902-40d0-ba83-0447b9d6f8b7"){
                        authManageProjects = true;
                        authUserDisplayItems();
                    }
                });
            }
        },
    });

}


function authUserDisplayItems(){

    if(authManageProjects){
        $(".auth-display").removeClass("d-none");
    }

}


function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function init(){
    checkUserAuthToManageProject();
    setWeekSelectDropdown();
    getClientsProjects();
    setProjectHours();
    signOutDashboard();
    deleteWeek();
    getMonthlySummary()
    getPreviousMonthlySummary()
}


export default {init}